import React from 'react';
import PropTypes from 'prop-types';

import LongTextWithToggle from 'components/Layout/LongTextWithToggle';
import useWindowSize from 'utils/hooks/useWindowSize';

const EventDescription = ({ sDescription }) => {
  const bDescriptionHasHtml = sDescription.search('</') !== -1;
  const oWindowSize = useWindowSize();

  let descriptionMarkup = (
    <p className='eventDetails__description'>{sDescription}</p>
  );
  if (bDescriptionHasHtml) {
    descriptionMarkup = (
      <p
        className='eventDetails__description'
        dangerouslySetInnerHTML={{ __html: sDescription }}
      />
    );
  } else if (oWindowSize.width < 640) {
    descriptionMarkup = (
      <LongTextWithToggle
        sText={sDescription}
        sClassName='eventDetails__description'
      />
    );
  }
  return (
    <>
      <h3 className='eventDetails__descriptionHeader t-paragraph--medium'>
        About
      </h3>
      {descriptionMarkup}
    </>
  );
};

export default EventDescription;

EventDescription.propTypes = {
  sDescription: PropTypes.string,
};

EventDescription.defaultProps = {
  sDescription: '',
};
